export default __webpack_public_path__ + "static/media/sns-blog.57ddd672.svg";